import { MASSIVA_ACCESS_PERMISSIONS } from 'dashboard/constants/permissions';

// Quem vê a Massiva: admin ou papel com `massiva_access`, em conta com o
// Studio ligado. Definição ÚNICA pro chip da barra superior e pra qualquer
// outro atalho — a sidebar aplica a mesma regra pelo mecanismo genérico
// (`requiredPermissions` do item + gate `isStudioEnabled` do grupo AI Studio)
// e a rota `studio_massiva` pelas `permissions` dela. Se a regra mudar, mudar
// aqui e lá juntos.
export const canAccessMassiva = ({ permissions = [], studioEnabled }) =>
  Boolean(studioEnabled) &&
  (permissions.includes('administrator') ||
    permissions.includes(MASSIVA_ACCESS_PERMISSIONS));
